module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epslf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vi. ",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vii. ",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Words are hoops")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Through which to leap upon meanings,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Which are horses’ backs,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Bare, moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_c('i', [_vm._v("Witter Bynner, “Horses,” 1919")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-110f532a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Fischer-OA-0006.vue
// module id = 69
// module chunks = 0